import { render } from "./contracts-invoices.vue?vue&type=template&id=3d61be46&scoped=true"
import script from "./contracts-invoices.vue?vue&type=script&lang=js"
export * from "./contracts-invoices.vue?vue&type=script&lang=js"

import "./contracts-invoices.vue?vue&type=style&index=0&id=3d61be46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d61be46"]])

export default __exports__